/*
  Do not pull in the bottom sheet until we can refactor the poptart in pulse and redo the existing drawers.
*/

import React from 'react'

import { BottomSheetTransition } from '@mxenabled/mxui'

import Dialog from '@mui/material/Dialog'

interface BottomSheetBaseProps {
  allowScroll?: boolean
  children: any
  height?: number | string
  isMobile?: boolean
  isOpen: boolean
  onClose?: () => void
  showBackground?: boolean
  width?: number | string
}

const BottomSheetBase: React.FC<BottomSheetBaseProps> = ({
  allowScroll,
  children,
  height,
  isMobile,
  isOpen = false,
  onClose,
  showBackground = false,
  width = 450,
}) => {
  const [shouldEnableScroll, setShouldEnableScroll] = React.useState(false)

  React.useEffect(() => {
    setShouldEnableScroll(!!allowScroll)
  }, [allowScroll])

  return (
    <Dialog
      disableScrollLock={shouldEnableScroll}
      hideBackdrop={showBackground}
      onClose={onClose}
      open={isOpen}
      scroll="paper"
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            bottom: 0,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            left: '50%',
            m: 0,
            maxHeight: height ?? '50%',
            maxWidth: width,
            position: 'fixed',
            transform: 'translateX(-50%)',
            width: isMobile ? '100%' : '80%',
          },
        },
      }}
      slots={{ transition: BottomSheetTransition }}
      sx={{
        '& .MuiBackdrop-root': {
          /*
            Do not remove the rgba from the background. the default backgroundColor is incompatable with the other 
            pulse components such as the differnt drawers and native pulse dialogs.
          */
          backgroundColor: 'rgba(213, 216, 216, 0.64)',
        },
      }}
    >
      {children}
    </Dialog>
  )
}

export const BottomSheet = BottomSheetBase
